import React from 'react';
import { useSelector } from 'react-redux';
import { FREE_PACKAGE_CODES } from '@src/constants/package';
import { isNumber } from 'lodash';
import { useLocation } from 'react-router-dom';
import {
  checkLowCredits,
  checkPackageExpired,
  hasPackageExpiringSoon,
} from '@src/services/package';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import Routes from '@src/constants/route';
import {
  useCheckEducatorsRoute,
  useCheckProjectRoute,
} from '@src/hooks/useCheckDubbingRoute';
import useTotalCredits from '@src/hooks/useTotalCredits';
import { StyledContent } from './index.style';

const Content = ({
  children,
  openSidebar,
  headerVoucher,
  newPricingOverviewEnabled,
}) => {
  const location = useLocation();
  const { totalCredits } = useTotalCredits();
  const { showPackageExpiringSoon, showNotifyLowCredits } = useSelector(
    (state) => state.layout,
  );
  const checkProjectPage = useCheckProjectRoute();
  const isEducatorsRoute = useCheckEducatorsRoute();
  const { getFeatureValue } = useFeatureFlags();
  const { user } = useSelector((state) => state.auth);

  const isMobileTTS = ['/m/text-to-speech', '/m/requests'].includes(
    location.pathname,
  );
  const isPricingPage =
    [Routes.PAYMENT].includes(location.pathname) &&
    !location.search.includes('package');

  const dateNotifyNearExpiry = getFeatureValue(
    FEATURE_KEYS.NOTIFY_NEAR_EXPIRY,
    {
      userId: user?.id,
      email: user?.email,
      phoneNumber: user?.phoneNumber,
    },
  );

  const usingFreePackage = FREE_PACKAGE_CODES.includes(user?.packageCode);
  const isPackageExpiringSoon =
    showPackageExpiringSoon &&
    isNumber(dateNotifyNearExpiry) &&
    !usingFreePackage &&
    location.pathname === Routes.MOBILE_TTS &&
    !!user?.packageExpiryDate &&
    hasPackageExpiringSoon(user?.packageExpiryDate, dateNotifyNearExpiry);

  const isLowCredits = checkLowCredits({
    totalCredits,
    packageCode: user?.packageCode,
  });
  const isPackageExpired = checkPackageExpired(user?.packageExpiryDate);
  const isNotifyLowCredits =
    isLowCredits &&
    !isPackageExpired &&
    location.pathname === Routes.MOBILE_TTS;
  const showNotifyLowCreditsBanner = isNotifyLowCredits && showNotifyLowCredits;

  return (
    <StyledContent
      headerVoucher={headerVoucher}
      openSidebar={openSidebar}
      isMobileTTS={isMobileTTS}
      isPricingPage={isPricingPage}
      isEducatorsRoute={isEducatorsRoute}
      isProjectPage={Boolean(checkProjectPage)}
      isPackageExpiringSoon={isPackageExpiringSoon}
      showNotifyLowCreditsBanner={showNotifyLowCreditsBanner}
      newPricingOverviewEnabled={newPricingOverviewEnabled}
    >
      <div className="content-layout">{children}</div>
    </StyledContent>
  );
};

export default Content;
